/** @module csi/image/ImageSetAction **/
define([
	"dojo/_base/lang",
	"csi/def/Action",
	"csi/view/PluginFactory",
	"csi/view/ToolbarPluginButton",
	"csi/image/ImageEditorPluginMixin"
], function(lang,Action,PluginFactory,ToolbarPluginButton,ImageEditorPluginMixin) {

	return PluginFactory.declare("setaction", [ToolbarPluginButton, ImageEditorPluginMixin], {
		/**
		 * Set the action for setting cropper action
		 */
		constructor: function() {
			this.defAction = lang.mixin(new Action(), {
				m_id: "ImageEditorSetAction",
				m_onAction: "setCropperAction"
			});
			this.defAction.setMaterialIcon("done");
			this.defAction.resolve();
		}
	});
});